var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141,
    height: 166.42,
    viewBox: "0 0 141 166.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_162",
    x: 0,
    y: 25.42,
    width: 141,
    height: 141,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 62,
    height: 62,
    transform: "translate(0.063 0.063)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(-344.5 -2624.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(0 66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M361.162,128.6l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668a3.476,3.476,0,0,0-1.163-1.557Z",
    transform: "translate(81.31 2448.929)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M735.046,77.5l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,735.046,77.5Z",
    transform: "translate(-319.479 2492.157)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(-564.132 180.631) rotate(-17)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 11.168,
    cy: 22.788,
    rx: 11.168,
    ry: 22.788,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M549.9,218.79c4.473-26.838.045-53.578,0-53.845l-.87.147c.045.265,4.448,26.866,0,53.553Z",
    transform: "translate(-365.109 2387.603)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.883,
    height: 11.453,
    transform: "translate(175.569 2564.97) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 11.454,
    height: 0.883,
    transform: "translate(186.229 2572.303) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(696.433 34.469) rotate(11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8-2",
    "data-name": "Ellipse 8",
    cx: 9.109,
    cy: 18.587,
    rx: 9.109,
    ry: 18.587,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853-2",
    "data-name": "Path 853",
    d: "M549.735,208.862c3.648-21.889.037-43.7,0-43.917l-.71.12c.037.217,3.628,21.912,0,43.679Z",
    transform: "translate(-366.818 2386.452)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182-2",
    "data-name": "Rectangle 182",
    width: 0.72,
    height: 9.342,
    transform: "translate(175.399 2561.529) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183-2",
    "data-name": "Rectangle 183",
    width: 9.342,
    height: 0.72,
    transform: "translate(184.094 2567.51) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M663.565,209.25l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,663.565,209.25Z",
    transform: "translate(-242.272 2375.306)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 344.5, 2624.08)",
    filter: "url(#Rectangle_162)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162-2",
    "data-name": "Rectangle 162",
    width: 114,
    height: 114,
    rx: 5,
    transform: "translate(13.5 35.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(382.937 2687.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M1.941,0H60.185a1.941,1.941,0,0,1,1.941,1.941V5.824a1.941,1.941,0,0,1-1.941,1.941H1.941A1.941,1.941,0,0,1,0,5.824V1.941A1.941,1.941,0,0,1,1.941,0",
    transform: "translate(0 0)",
    fill: "#7f65d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M32,64H86.361v44.653a1.941,1.941,0,0,1-1.941,1.941H33.941A1.941,1.941,0,0,1,32,108.653Z",
    transform: "translate(-28.117 -56.234)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 2,
    height: 4,
    transform: "translate(30.063 54.063)",
    fill: "#7f65d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M234.912,464A2.912,2.912,0,1,1,232,466.912,2.912,2.912,0,0,1,234.912,464",
    transform: "translate(-203.849 -407.698)",
    fill: "#7f65d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M72.278,65.629H17.918a1.941,1.941,0,0,1-1.941-1.941c0-.1-1.476,0,58.243,0a1.941,1.941,0,0,1-1.941,1.941",
    transform: "translate(-14.035 -55.922)",
    fill: "#2b00be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M248.971,191.3a.971.971,0,0,1-.971-.971V168.971a.971.971,0,1,1,1.941,0v21.356a.971.971,0,0,1-.971.971",
    transform: "translate(-217.908 -147.615)",
    fill: "#7f65d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M145.975,268.619a.971.971,0,0,1-.971-.971v-8.737a.971.971,0,0,0-.971-.971H114.912a.971.971,0,0,0-.971.971v8.737a.971.971,0,1,1-1.941,0v-8.737A2.912,2.912,0,0,1,114.912,256h29.122a2.912,2.912,0,0,1,2.912,2.912v8.737a.971.971,0,0,1-.971.971",
    transform: "translate(-98.41 -224.937)",
    fill: "#7f65d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M199.766,112A7.766,7.766,0,1,1,192,119.766,7.766,7.766,0,0,1,199.766,112",
    transform: "translate(-168.703 -98.41)",
    fill: "#95b2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M70.8,296a6.8,6.8,0,1,1-6.8,6.8,6.8,6.8,0,0,1,6.8-6.8",
    transform: "translate(-56.234 -260.083)",
    fill: "#95b2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M206.8,296a6.8,6.8,0,1,1-6.8,6.8,6.8,6.8,0,0,1,6.8-6.8",
    transform: "translate(-175.732 -260.083)",
    fill: "#95b2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M342.8,296a6.8,6.8,0,1,1-6.8,6.8,6.8,6.8,0,0,1,6.8-6.8",
    transform: "translate(-295.23 -260.083)",
    fill: "#95b2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M222.981,171.454a5.824,5.824,0,0,1-10.581,0,5.824,5.824,0,0,1,10.581,0",
    transform: "translate(-186.627 -147.671)",
    fill: "#dee6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M234.912,128A2.912,2.912,0,1,1,232,130.912,2.912,2.912,0,0,1,234.912,128",
    transform: "translate(-203.849 -112.468)",
    fill: "#dee6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M92.191,346.783a4.854,4.854,0,0,1-8.911,0,4.854,4.854,0,0,1,8.911,0",
    transform: "translate(-73.175 -302.129)",
    fill: "#dee6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M98.912,312A2.912,2.912,0,1,1,96,314.912,2.912,2.912,0,0,1,98.912,312",
    transform: "translate(-84.351 -274.142)",
    fill: "#dee6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M228.191,346.783a4.854,4.854,0,0,1-8.911,0,4.854,4.854,0,0,1,8.911,0",
    transform: "translate(-192.672 -302.129)",
    fill: "#dee6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M234.912,312A2.912,2.912,0,1,1,232,314.912,2.912,2.912,0,0,1,234.912,312",
    transform: "translate(-203.849 -274.142)",
    fill: "#dee6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M364.191,346.783a4.854,4.854,0,0,1-8.911,0,4.854,4.854,0,0,1,8.911,0",
    transform: "translate(-312.17 -302.129)",
    fill: "#dee6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M370.912,312A2.912,2.912,0,1,1,368,314.912,2.912,2.912,0,0,1,370.912,312",
    transform: "translate(-323.347 -274.142)",
    fill: "#dee6ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 8,
    height: 3,
    transform: "translate(8.063 13.063)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 8,
    height: 2,
    transform: "translate(8.063 21.063)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 11,
    height: 2,
    transform: "translate(8.063 17.063)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 7,
    height: 2,
    transform: "translate(47.063 26.063)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 9,
    height: 2,
    transform: "translate(45.063 22.063)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M32.737,25.941H24.971a.971.971,0,0,1,0-1.941h7.766a.971.971,0,1,1,0,1.941",
    transform: "translate(-21.088 -21.088)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgChart);
export default __webpack_public_path__ + "static/media/org-chart.9700729be1639841f36ab2474e488a39.svg";
export { ForwardRef as ReactComponent };